import React from "react";
import "./usecase.css";
import agentOne from "../../assets/agent-analyst-use-case.svg";
import dot from "../../assets/dots.svg";
// import hoverIcon from "../../assets/use-case-hover-icon.svg";
import agentTwo from "../../assets/autonomusops-new.svg";
import agentThree from "../../assets/agent-sre-use-case.svg";
import agentFour from "../../assets/agent-hr-use-case.svg";
import agentFive from "../../assets/agent-search-new.svg";

const UseCasesSection = () => {
  return (
    <section className="use-cases-section" id="agents">
      <div className="container">
        <div className="use-cases-section-wrapper">
          <div className="section-heading">
            <div className="section-tag">
              <img src={dot} alt="dot-image" />
              <p className="gradient-border-heading">SRE Agents in Action</p>
            </div>
            <h2>Meet the Agents Behind Observability 3.0</h2>
            <p>
              A fleet of AI agents automates monitoring, remediation,
              optimization, and compliance to keep systems reliable and
              efficient
            </p>
          </div>
          <div className="teammates-nine-cards-wrapper">
            <div className="tab-content-wrapper row">
              <div className="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 teammates-hover-card agent-label">
                <div className="hover-card-inner">
                  {/* <div className="use-case-hover-icon">
            <img src={hoverIcon} alt="use-case-hover-icon" />
          </div> */}
                  <div className="flex-card-wrapper">
                    <div className="card-text">
                      <h3>Anomaly Detection Agent</h3>
                      <p>
                        Continuously scans metrics, logs, and traces to spot
                        deviations early, reducing manual effort and protecting
                        everyday service health.
                      </p>
                    </div>
                    <div className="use-case-image">
                      <img src={agentOne} alt="use-case-image" loading="lazy" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-md-5 col-lg-5 col-xl-5 teammates-hover-card agent-analyst">
                <div className="hover-card-inner">
                  {/* <div className="use-case-hover-icon">
            <img src={hoverIcon} alt="use-case-hover-icon" />
          </div> */}
                  <div className="use-case-image">
                    <img src={agentTwo} alt="use-case-image" loading="lazy" />
                  </div>
                  <h3>Correlation Agent</h3>
                  <p>
                    Connects signals across apps and infrastructure, linking
                    related alerts to shared causes in real time to cut noise
                    and speed insight.
                  </p>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 teammates-hover-card agent-sre">
                <div className="hover-card-inner">
                  {/* <div className="use-case-hover-icon">
            <img src={hoverIcon} alt="use-case-hover-icon" />
          </div> */}
                  <div className="use-case-image">
                    <img src={agentThree} alt="use-case-image" loading="lazy" />
                  </div>
                  <h3>RCA Agent</h3>
                  <p>
                    Traces incidents to root causes using causal graphs and
                    timelines, clarifying blast radius and accelerating
                    accurate, durable fixes.
                  </p>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 teammates-hover-card agent-hr">
                <div className="hover-card-inner">
                  {/* <div className="use-case-hover-icon">
            <img src={hoverIcon} alt="use-case-hover-icon" />
          </div> */}
                  <div className="use-case-image">
                    <img src={agentFour} alt="use-case-image" loading="lazy" />
                  </div>
                  <h3>Remediation Agent</h3>
                  <p>
                    Executes safe automated runbooks and fixes, validates
                    impact, and restores service quickly while preserving
                    guardrails and audit trails.
                  </p>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 teammates-hover-card agent-search">
                <div className="hover-card-inner">
                  {/* <div className="use-case-hover-icon">
            <img src={hoverIcon} alt="use-case-hover-icon" />
          </div> */}
                  <div className="use-case-image">
                    <img src={agentFive} alt="use-case-image" loading="lazy" />
                  </div>
                  <h3>Xenonify (FinOps Agent)</h3>
                  <p>
                    Right-sizes resources, enforces budgets and tags, and flags
                    waste in real time so teams stay cost-efficient without
                    slowing delivery.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UseCasesSection;
